import { Client, buildBlockRecord } from '@datocms/cma-client-browser';

import { WebshopItemForTranslateResponse } from './queries'; // Ensure the path to your types is correct

async function updateProduct(
  apiToken: string,
  productId: string,
  locale: string,
  productData: WebshopItemForTranslateResponse
): Promise<void> {
  const client = new Client({
    apiToken,
  });

  locale = locale.replaceAll('_', '-');

  const currentData = await client.items.find(productId) as any;
  console.log(currentData)

  currentData.meta = {current_version: currentData.meta.current_version}; // Optimistic locking

  currentData.product_name[locale] = productData.productName;
  currentData.title[locale] = productData.title;
  currentData.subtitle[locale] = productData.subtitle;
  currentData.preface[locale] = productData.preface;
  currentData.what_is_paragraphs[locale] = productData.whatIsParagraphs.map((a) => buildBlockRecord({item_type: { type: "item_type", id: "DnKosjctT6-lRIMI3FMbIA" }, ...a}));
  currentData.marketing_info[locale] = productData.marketingInfo.map(a => buildBlockRecord({
    item_type: { type: "item_type", id: "eJT1_VYXT0GpYdYsBBu4MQ" },
    title: a.title,
    text: a.text,
  }));
  currentData.dosing_text[locale] = productData.dosingText;
  currentData.dosing_paragraphs[locale] = productData.dosingParagraphs.map(a => buildBlockRecord({item_type: { type: "item_type", id: "DnKosjctT6-lRIMI3FMbIA" }, ...a}));
  currentData.ingredients[locale] = productData.ingredients.map(ingredient => buildBlockRecord({
    item_type: { type: "item_type", id: "dwaEwURtQ-6yY-1KqGpBjA" },
    name: ingredient.name,
    subingredients: ingredient.subingredients.map(sub => buildBlockRecord({
        item_type: { type: "item_type", id: "dwaEwURtQ-6yY-1KqGpBjA" },
        name: sub.name, 
        subingredients: [] 
    })),
  }));

  try {
    await client.items.update(productId, currentData);
    console.log('Product updated successfully');
  } catch (error) {
    console.error('Error updating product:', error);
    console.log(`${error}`)
    throw error;
  }
}

export default updateProduct;
